import {Component, OnInit} from '@angular/core';
import {SimulationsService} from '../simulation-list/simulations.service';
import {Router} from "@angular/router";
import {NewSimulationService} from "../new-simulation/new-simulation.service";
import {SimulationSavedComponent} from "../new-simulation/new-simulation.component";
import {MatDialog} from "@angular/material";

@Component({
    selector: 'app-saved-simulation',
    templateUrl: './saved-simulation.component.html',
    styleUrls: ['./saved-simulation.component.css'],
})
export class SavedSimulationComponent implements OnInit {

    public sectionData: any;
    public periodData;
    public colSpan = 2;
    // public currency: any;
    public agreementTypes = {
        'HD': 'Hidden Discount',
        'EC': 'Expenditure Cap',
        'PVA-V': 'Price Volume Agreement (Volume)',
        'PVA-S': 'Price Volume Agreement (Sale)',
        'FCPP': 'Fixed cost per patient',
        'DTI': 'Discounted treatment initiation',
        'UC': 'Utilisation Cap'
    };
    public isEdit = false;
    public changed = false;
    public changesSaved = true;
    public saveInProgress = false;


    firstChartData: any[];
    secondCharData: any[];
    thirdChartData: any[];
    fourthChartData: any[];

    constructor(private simService: SimulationsService, private newSimulationService: NewSimulationService, private router: Router, public dialog: MatDialog) {
        if (!this.simService.loadedSimulation) {
            this.router.navigate(['/simulation-list']);
        }
    }

    ngOnInit() {
        this.initPeriodData();
    }

    private initPeriodData() {
        this.sectionData = this.simService.loadedSimulation;

        this.firstChartData = this.sectionData.firstChartData;
        this.secondCharData = this.sectionData.secondCharData;
        this.thirdChartData = this.sectionData.thirdChartData;
        this.fourthChartData = this.sectionData.fourthChartData;

        const numberOfCycles = this.sectionData.numberOfCycles;

        this.colSpan = numberOfCycles;

        this.periodData = [];

        for (let i = 0; i < numberOfCycles; i++) {
            this.periodData.push(i);
        }
    }

    onEditClicked() {

        if (this.isEdit && this.changed) {

            const that = this;

            this.newSimulationService.fetchResultForData(this.sectionData, this.sectionData.data['Simulation_type'])
                .subscribe(result => {

                    for (const key in result) {
                        that.sectionData[key] = result[key];
                    }
                    that.sectionData.Currency = that.sectionData.data.Currency;
                    that.simService.prepareChartData(that.sectionData, that.sectionData);

                    this.initPeriodData();

                    that.changed = false;
                    that.isEdit = false;
                    that.changesSaved = false;


                }, error => {

                });
        } else {
            this.initPeriodData();
            this.isEdit = !this.isEdit;
        }
    }

    onSaveClicked() {

        const that = this;
        this.saveInProgress = true;

        that.newSimulationService.editSimulation(that.sectionData)
            .subscribe((result) => {

                const dialogRef = this.dialog.open(SimulationSavedComponent);
                dialogRef.afterClosed().subscribe(result => {
                    that.changesSaved = true;
                    that.saveInProgress = false;
                });

            }, (error) => {
                that.saveInProgress = false;
            });
    }


    onDeleteClicked() {

        const that = this;

        this.newSimulationService.deleteSimulation(this.sectionData)
            .subscribe((result) => {
                that.router.navigate(['/simulation-list']);
            }, error2 => {

            });
    }
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/saved-simulation/saved-simulation.component.ts